<template>
  <div 
    class="selector-overlay-container" 
    :class="{
      'horizontal': horizontal,
    }"
  >
    <slot></slot>
    <SelectorOverlay ref="overlay"/>
  </div>
</template>

<script>
import SelectorOverlay from './SelectorOverlay';
import SelectorOverlayItem from './SelectorOverlayItem';

export default {
  props: {
    reactOn: {
      
    },
    severalReact: {
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
    },
    keyName: {
      
    },
    horizontal: {
      default: false,
      type: Boolean,
    },
  },
  watch: {
    reactOn: function(to, from) {
      if(!this.severalReact) {
        this.$nextTick(() => {
          this.processOverlay();
        });
      }
    },
    value: function (to, from) {
      this.$nextTick(() => {
        this.processOverlay();
      });
    }
  },
  components: {
    SelectorOverlay,
    SelectorOverlayItem,
  },
  methods: {
    processOverlay() {
      const key = this.keyName 
        ? this.value[this.keyName]
        : this.value;

      if(!key) return;      

      const el = this.$refs['overlay'].$el;

      let item = this.$children.find(n => {
        return n.$options.name == 'selector-overlay-item' && n.$vnode.key == key;
      });

      if(!item) {
        el.style.opacity = 0;
      } else {
        item = item.$el
        const ptr = item.getElementsByClassName('--selector-overlay-pointer');
        if(ptr.length) {
          item = ptr[0];
        }

        const rect = item.getBoundingClientRect();
        const offset = item.relativeOffset(this.$el);

        el.style.transform = `translate(${offset.x}px, ${offset.y}px)`;
        el.style.width = `${rect.width}px`;
        el.style.height = `${rect.height}px`;
        el.style.opacity = 1;
      }

      
    }
  },
  mounted() {
    this.processOverlay();
    window.addEventListener('resize', this.processOverlay);
  },
  created() {

    this._interval = setInterval(() => {
      this.processOverlay();
    }, 1000);

    if(this.severalReact) {
      // TODO: сделать что бы реагировало на несколько переменных
    }
  },
  destroyed() {
    clearInterval(this._interval);
    window.removeEventListener('resize', this.processOverlay);
  }
}
</script>

<style lang="scss" scoped>

.selector-overlay-container {
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  width: 100%;
  height: 100%;
  z-index: 1;

  &.horizontal {
    flex-direction: row;
  }
}

</style>